export default __webpack_public_path__ + "static/media/dowanloadapp.b0b28f82.png";